import React, { useState } from "react";
import { Col, Input, Row, Table, Form, Dropdown, Button, Popover } from "antd";
import { SearchOutlined, FilterOutlined, CloseOutlined, DownloadOutlined } from "@ant-design/icons";
import styled from "styled-components";
import ViewCourse from "./ViewCourse";
import COLORS from "../../../../common/Colors";
import CourseReportStyle from "./style";

const StyledTable = styled(Table)`
  padding-top: 20px;
  table {
    width: 100% !important;
  }
  .ant-table-content {
    overflow-x: auto;
    white-space: nowrap;
    border: 1px solid #00000024;
    border-radius: 10px;
  }
  .ant-table-cell {
    padding: 20px;
  }
  .normal-column {
    min-width: 300px;
    white-space: normal;
  }
  .ant-table-thead .ant-table-cell {
    font-weight: 600;
    font-size: 0.9rem;
    color: ${COLORS.SECONDARY_BLACK};
    white-space: nowrap;
  }
  .non-white {
    background: #f9f9f9;
  }
  .ant-table-thead > tr > th::before {
    display: none !important;
  }

  .ant-table-cell-row-hover {
    background: #e3e8fc !important;
  }
`;

const StyledImg = styled.img`
  cursor: pointer;
`;

const UserReport = () => {
  const [tableViewData, setTableViewData] = useState();
  const [userRenderView, setUserRenderView] = useState("table-view");
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [filterValue, setFilterValue] = useState("")
  const hanldeClickEdit = () => {};

  const columns1 = [
    {
      title: "User",
      dataIndex: "user",
      key: "user",
      sorter: (a, b) => a.user - b.user,
    },
    {
      title: "User type",
      dataIndex: "userType",
      key: "userType",
    },
    {
      title: "Last login",
      dataIndex: "lastLogin",
      key: "lastLogin",
    },
    {
      title: "Assigned courses",
      dataIndex: "assignedCourses",
      key: "assignedCourses",
    },  
    {
      title: "Completed courses",
      dataIndex: "completedCourses",
      key: "completedCourses",
    },  
    {
      title: "Points",
      dataIndex: "points",
      key: "points",
    },  
    {
      title: "Badges",
      dataIndex: "badges",
      key: "badges",
    },  
    {
      title: "Level",
      dataIndex: "level",
      key: "level",
    },  
  ];

  const dataSource1 = [
    {
      key: 1,
      user: "Guhan",
      userType: "Instructor",
      lastLogin: "-",
      assignedCourses: "-",
      completedCourses: "-",
      points: "0",
      badges: "0",
      level: "1"
    },
  ];

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const onChangeSortedTable = (pagination, filters, sorter, extra) => {
    console.log("params", pagination, filters, sorter, extra);
  };

  const handleClickData = (data) => {
    setUserRenderView("view-table");
    setTableViewData(data);
  };

const CourserOverviewData = [
  {
      label: "Completion rate",
      value: "0.0%"
  },
  {
      label: "Completed courses",
      value: 0
  },
  {
      label: "Courses in progress",
      value: 0
  },
  {
      label: "Courses not passed",
      value: 0
  },
  {
      label: "Courses not started",
      value: 0
  },
  {
      label: "Training time",
      value: "0h 0m"
  },
]

const items = [
  {
    label: "Active",
    key: "active",  // Adding a key for better item identification
  },
  {
    label: "InActive",
    key: "inactive",
  },
];

const handleClickFilter = (data) => {
  setFilterValue(data.label)
}

  return (
    <>
      <CourseReportStyle>
        {userRenderView === "table-view" ? (
          <>
            <div className="user-title-container users-menu-filter-container">
              <h1 className="user-menu-title">User Reports</h1>
            </div>

            <div className="course-overview-data-box">
              {CourserOverviewData.map((item, index) => {
                return(
                  <div key={index}>
                      <p className="overview-value">{item.value}</p>
                      <p className="overview-label">{item.label}</p>
                  </div>
                )
              })}
            </div>
            <br></br>
            <Row className="users-menu-filter-container">
              <Col>
                <Form.Item name="search" className="search-input-field">
                  <Input suffix={<SearchOutlined />} placeholder="Search" />
                </Form.Item>
              </Col>
              
              <Dropdown
                menu={{
                  items,
                  onClick: ({ key, domEvent }) => {
                    // Find the clicked item based on the key
                    const clickedItem = items.find(item => item.key === key);
                    handleClickFilter(clickedItem);
                  },
                }}
                trigger={['click']}
              >
                <Popover placement="top" content="Filters">
                  <div className="filter_icon_box"><FilterOutlined /></div>
                </Popover>
              </Dropdown>

              {filterValue && <Button className="active_filter_button"><CloseOutlined onClick={() => setFilterValue("")}/> {filterValue}</Button> }
            </Row>
            <StyledTable
              // rowSelection={rowSelection}
              dataSource={dataSource1}
              columns={columns1}
              rowClassName={(record, index) =>
                index % 2 === 0 ? "" : "non-white"
              }
              rowKey="checkin_id"
              id="Table"
              onChange={onChangeSortedTable}
              showSorterTooltip={{
                target: "sorter-icon",
              }}
              onRow={(record, rowIndex) => {
                return {
                  onClick: () => {
                    handleClickData(record);
                  },
                };
              }}
            />

            <div className="download_csv_con">
              <Popover placement="top" content="Save as CSV">
                <DownloadOutlined />
              </Popover>
            </div>
          </>
        ) : (
          <ViewCourse
            tableViewData={tableViewData}
            setUserRenderView={setUserRenderView}
          />
        )}
      </CourseReportStyle>
    </>
  );
};

export default UserReport;
